import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import { useEffect } from "react";
import { DAYS } from "../../../../../enums/Enums";
import classes from "../ToggleButtons.module.css";
import Strings from "../../../../../resources/Strings";

const DaysToggleButtons = (props) => {
  useEffect(() => {
    if (props.handleError) {
      props.handleError({ [props.id]: props.hasError });
    }
  }, [props.value]);

  const handleChange = (event, newDays) => {
    props.onChange({ [props.id]: newDays });
  };

  return (
    <div className={classes.customToggleButtons}>
      <ToggleButtonGroup
        color="primary"
        id={props.id}
        name={props.id}
        value={props.value}
        onChange={handleChange}
        className={`${classes.group}`}
      >
        {Object.keys(DAYS).map((key) => {
          return (
            <ToggleButton
              key={key}
              className={classes.dayOption}
              value={key}
              classes={{ selected: classes.selected }}
            >
              <span className={classes.label}>{DAYS[key]?.name.slice(0, 3)}</span>
            </ToggleButton>
          );
        })}
      </ToggleButtonGroup>
      {props.isStepSubmitted && props.hasError && (
        <div className={classes.error}>
          {Strings.INPUT_ERROR_MESSAGES.IS_REQUIRED}
        </div>
      )}
    </div>
  );
};

export default DaysToggleButtons;
